var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.userManager.checkRole(['kt']))?_c('div',[_vm._v("Bạn không có quyền truy cập trang này")]):_c('div',[_c('statistics-page',{attrs:{"operatorId":"exportDepartmentsDaily","label":"Báo cáo Phòng","timeKey":"createdTime"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }